import { CalendarDays, FileText, Wallet } from 'lucide-react';
import { HeroEyebrow, HeroText, HeroTitle } from '../../components/ui/HeroCard';
import { useI18n } from '../../i18n/I18nProvider';
import { useTheme } from '../../theme/ThemeProvider';

/**
 * The confident side of the sign-in screen: the tenant's welcome, in the
 * tenant's own name where they have one, else the platform's.
 */
export function LoginHero() {
  const { t } = useI18n();
  const { displayName } = useTheme();
  const clinic = displayName || t('app.platformName');

  const points = [
    { icon: CalendarDays, label: t('auth.hero.pointAppointments') },
    { icon: FileText, label: t('auth.hero.pointResults') },
    { icon: Wallet, label: t('auth.hero.pointBilling') },
  ];

  return (
    <section className="bg-surface-high text-inverse flex flex-1 flex-col justify-between p-8 lg:p-12">
      <div>
        <HeroEyebrow>{t('auth.hero.eyebrow')}</HeroEyebrow>
        <HeroTitle className="max-w-[14ch]">{t('auth.hero.title', { clinic })}</HeroTitle>
        <HeroText className="mt-4 max-w-[42ch]">{t('auth.hero.text')}</HeroText>
      </div>

      <ul className="mt-10 space-y-4">
        {points.map(({ icon: Icon, label }) => (
          <li key={label} className="flex items-start gap-3">
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-inverse-fill">
              <Icon size={16} className="text-inverse" aria-hidden="true" />
            </span>
            <span className="text-body-sm text-inverse-variant">{label}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
